export const ITAU_FONT_TEXT = '"Itaú Text Pro", Arial, Helvetica, sans-serif';
export const ITAU_FONT_DISPLAY = '"Itaú Display Pro", Arial, Helvetica, sans-serif';
export const ITAU_FONT_SIZE_THRESHOLD = 19;
export const ITAU_BASE_FONT_SIZE = 16;
